import React from "react";
import "./review.scss";
import FormTitle from "../components/formTitle/FormTitle";
import apiClient from "../common/apiClient";
import Review from "./Review";
import SecondaryButton from "../components/button/SecondaryButton";
import Button from "../components/button/Button";
import { ToCamelCase, ProductsAdded } from '../common/common';

class SimpleCartReview extends Review {
  constructor(props) {
    super(props);

    this.linerBundleFormTypeId = 14;
    this.footBundleFormTypeId = 15;

    this.state = {
      cartData:[],
      indexedCartData:[]
    };
  }

  componentDidMount() {
    super.componentDidMount();
    this.loadData();
  }
  
  async getProductBasket(formTypeId) {
    try {
      let config = { headers: {} };
      if (this.props.uniqueId != null) {
        config.headers.UniqueId = this.props.uniqueId;
      }

      const { data } = await apiClient.get(
        "multiProduct/" + formTypeId,
        config
      );

      return data;
    }
    catch (error) {
      console.log(error)
    }
  }

    async loadData() {
    try {
      let config = { headers: {} };
      if (this.props.uniqueId != null) {
        config.headers.UniqueId = this.props.uniqueId;
      }

      let currentBasket = null;
      const isMulti = await ProductsAdded(this.props.formTypeId, this.props.uniqueId);
      if (isMulti) {
        currentBasket = await this.getProductBasket(this.props.formTypeId);
      }

      let cartData = (
        await apiClient.get(
          `cart/${this.props.formTypeId}?isMulti=${isMulti}&basketId=${currentBasket?.id}`,
          config
        )
      ).data;

      config = {
        headers: {
          UniqueId: this.props.uniqueId
        },
        params: {
          fieldNames: ["linerPromiseShipDates"],
        },
      };

      const fieldInputs = (
        await apiClient.get("fieldInputs/" + this.props.formTypeId,config)
      ).data;

      if (fieldInputs === null) {
        if (parseInt(this.props.formTypeId) === this.linerBundleFormTypeId || parseInt(this.props.formTypeId) == this.footBundleFormTypeId) {
          const linerPartNumbers = cartData.map(cd => {
            return { partNumber: cd.partNumber, sourceId: cd.sourceId }
          })

          let linerShipDateConfig = {
            params: {
              linerPartNumbers: JSON.stringify(linerPartNumbers),
            },
          };

          let shippingDates = (
            await apiClient.get("linerShipDate/",
              linerShipDateConfig
            )
          ).data;

          cartData.map(cd => {
            cd.scheduledShipDate = this.formatShipDate(shippingDates.find((sd) => sd?.partNumber === cd.partNumber) ?? null);
            cd.substantialLeadTime = shippingDates.find((sd) => sd?.partNumber === cd.partNumber)?.leadTimeDays >= 10;
            return cd;
          })
        } else {
          cartData.map(cd => {
            return cd;
          })
        }
      } else {
        let parsedFieldOptions = fieldInputs.map(fi => {
          fi.stringData = JSON.parse(fi.stringData);
          return fi;
        });
        cartData.map(cd => {
          const cartFieldInput = parsedFieldOptions.find((fi) => fi.stringData.fieldInputId === cd.fieldInputId);
          cd.scheduledShipDate = cartFieldInput?.stringData.shipDate ?? null;
          return cd;
        })
      }
      
      let cartWithIndex = Object.groupBy(cartData, ({ formIndex }) => formIndex);
      if ("null" in cartWithIndex) {
        cartWithIndex = Object.groupBy(cartData, ({ sourceId }) => sourceId);
      }
      const formIndexedCart = Object.values(cartWithIndex);

      this.setState({
       cartData:cartData,
       indexedCartData:formIndexedCart
      });
    } catch (error) {
      console.log(error);
    }
    
    super.loadData();
    this.setState({ isLoaded: true });
  }

  async saveData() {

    let data = [];

    this.state.cartData.forEach((cartItem, index) => {
      if (cartItem.scheduledShipDate !== null) {
        data.push({
          fieldName: "LinerPromiseShipDates",
          stringData: JSON.stringify({ fieldInputId: cartItem.fieldInputId, shipDate: cartItem.scheduledShipDate }),
          dataIndex: index
        });
      }
    });

    const isMulti = await ProductsAdded(this.props.formTypeId, this.props.uniqueId);

    await apiClient.post(
      `fieldInputs/${this.props.formTypeId}?isMulti=${isMulti}&parentFormTypeId=${this.props.parentFormTypeId}`,
      data
    );
    
    let url = `orders/${this.props.formTypeId}`
    if (isMulti) {
      url += `?isBilateral=false&isMulti=true`
    }

    await apiClient.post(
      url
    );
  }

  cartTotal(cart) {
    let total = 0;
    cart.forEach((item) => {
      if (item.quantity > 0 && item.price > 0) {
        total += item.price * item.quantity;
      }
    });

    return total;
  }

  formatPrice(price) {
    return Number(price).toFixed(2);
  }

  render() {
    if (!this.state.isLoaded) return this.makeLoadingText();
    return (
      <>
        <div
          className={`reviewWrapper ${
            this.props.isBilateral ? "bilateralWrapper" : ""
          }`}
        >
          {!this.props.isBilateral && (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <FormTitle
                title="Order Review"
                description=""
              />
            </div>
          )}

          <div className="reviews">
            <div>
              {!this.props.showOrderSummary && (
                <div className="summaryName">
                  <h4>Order Summary</h4>
                  {this.props.isBilateral && (
                    <div className="bileralName">
                      <h2>{this.props.bilateralName}</h2>
                    </div>
                  )}
                  {!this.props.isBilateral && <h2>{this.props.formName}</h2>}
                </div>
              )}
              <div className="summaaryHeader">
                <h2>
                  {this.props.name}
                  {this.props.isBilateral &&
                    " (Order " + this.props.orderNumber + ")"}
                </h2>
                <div className="poDate">
                  <div className="po">
                    <span>PO:</span>
                    <p>{this.state.poNumber}</p>
                  </div>
                  {this.state.soNumber &&
                      <div className="po">
                        <span>SO Number:</span>
                        <p>{this.state.soNumber}</p>
                      </div>
                    }
                  {(parseInt(this.props.formTypeId) !== this.linerBundleFormTypeId && parseInt(this.props.formTypeId) !== this.footBundleFormTypeId) &&
                    <div className="po">
                      <span>SSD:</span>
                      <p>{this.formatShipDate(this.state.estimatedShipDate)}</p>
                    </div>}
                </div>
              </div>
            </div>
            <div className="information">
              <div className="subDetail">
                {this.props.isMulti ? <h3 className="pb-3 font-weight-bold">Products</h3> : <h3>Products</h3>}

                <div className="detailWrapper flex-wrap">
                  {this.state.indexedCartData.map((indexedItem, index) => {
                    return (
                      <div key={index}>
                        {this.props.isMulti && <div className="subDetail"><h3>{ToCamelCase(indexedItem[0].sourceId)}</h3></div>}
                        <div className="d-flex flex-wrap" style={{gap: "14px"}}>
                          {indexedItem.map(item => {
                            return (
                              <div key={item.partNumber} className="detail">
                                <div className="detailContentWrapper">
                                  <div className="content">
                                    <p>
                                      {item.name}
                                    </p>
                                  </div>
                                  <div className="content">
                                    <span>Part Number:</span>
                                    <p>
                                      {item.partNumber}
                                    </p>
                                  </div>
                                  <div className="content">
                                    <span>Quantity:</span>
                                    <p>
                                      {item.quantity}
                                    </p>
                                  </div>
                                  {(parseInt(this.props.formTypeId) === this.linerBundleFormTypeId || parseInt(this.props.formTypeId) == this.footBundleFormTypeId) && item.scheduledShipDate !== null ?
                                    <div className="content">
                                      <span>Scheduled Ship Date:</span>
                                      <p style={{ alignContent: "end", color: (item.substantialLeadTime) ? "red" : "black" }}>
                                        {item.scheduledShipDate}
                                      </p>
                                    </div> : <></>}
                                </div>
                              </div>
                            )
                          })
                          }
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>

            {!this.props.showOrderInfo && (
              <div className="information clinicInfo">
                <h3>Clinic Info</h3>
                <div className="patientInfo">
                  <div className="customerInfo">
                    <div className="patientSubInfo">
                      <span>Bill to account:</span>
                      <p>{this.state.accountNumber}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Clinic:</span>
                      <p>{this.state.clinicName}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Clinician Name:</span>
                      <p>{this.state.prosthetistName}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Email Address</span>
                      <p>{this.state.email}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Phone</span>
                      <p>{this.state.phone}</p>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="information">
              <h3>Shipping Information</h3>
              <div className="patientInfo">
                <div className="">
                  <div className="borderBotom">
                    <div className="patientSubInfo">
                      <span>Shipping Address:</span>
                      <p>{this.state.shippingAddress1}</p>
                      <p>{this.state.shippingAddress2}</p>
                      <p>{this.state.city}, {this.state.stateName}</p>
                      <p>{this.state.zip}</p>
                    </div>
                  </div>

                  <div className="shipping info">
                    <div className="patientSubInfo">
                      <span>Shipping Method:</span>
                      <p>{this.state.shippingMethodName}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Carrier:</span>
                      <p>{this.state.shippingCarrierName}</p>
                    </div>
                  </div>
                </div>
              </div>
              </div>

              {this.state.cartData.length > 0 ? (
                <div className="information mt-0">
                  <div className="mb-3"><h3>Cart</h3></div>
                  <div className="patientInfo">
                    <div className="cartSubInfo">
                      <table className="transparent-table table">
                        <thead>
                          <tr>
                            <th><span><b>Name</b></span></th>
                            <th></th>
                            <th><span><b>Part Number</b></span></th>
                            <th><span><b>Quantity</b></span></th>
                            <th className="text-right"><span><b>Price</b></span></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.indexedCartData.map((indexedItem, index) => {
                            return (
                              <React.Fragment key={index}>
                                {this.props.isMulti && <tr key={index} className="th-border" colSpan={5}><td className="th-padding"><div><b>{ToCamelCase(indexedItem[0].sourceId)}</b></div></td></tr>}
                                {indexedItem.map((item) => {
                                  return (
                                    <tr key={item.partNumber}>
                                      <td lg="6" sm="1">
                                        <div className="content">
                                          <p className="break-spaces">{item.name.trim()}</p>
                                        </div>
                                      </td>
                                      <td></td>
                                      <td>
                                        <p>{item.partNumber}</p>
                                      </td>
                                      <td>
                                        <p>{item.quantity}</p>
                                      </td>
                                      <td>
                                        <p className="text-right">${this.formatPrice(item.price)}</p>
                                      </td>
                                    </tr>
                                  )
                                })}
                              </React.Fragment>
                            )
                          })}
                          <tr>
                            <td>
                              <div>
                                <span><b>Total</b></span>
                              </div>
                            </td>
                            <td colSpan={4}>
                              <p className="text-right">
                                ${this.formatPrice(this.cartTotal(this.state.cartData))} 
                              </p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              ) : <></>}

            </div>
        </div>
        </div>
        {this.getNavButtons(this.props.uniqueId)}
        
      </>
    );
  }

  getNavButtons(uniqueId) {
    if (uniqueId != null) {
      return;
    }
  
    return (
      <div className="handelButtons">
            <div className="stepBtn">
              <SecondaryButton
                text="Back"
                onClick={() =>
                  this.props.handleBack(this?.props?.currentIndex - 1)
                }
                disabled={
                  this.props.activeOuterStep === 0 && this.props.innerStep === 0
                }
              />
              <Button
                text="Submit"
                disabled={this.state.isLoading}
                onClick={() => {
                  this.saveData();
                  this.props.handleNext(this?.props?.currentIndex);
                }}
              />
            </div>
          </div>
    );
  }
  
}


export default SimpleCartReview;